import React, { useState } from "react";
import { Aboutsec1, Aboutsec2 } from "./components/Aboutcomponent";
import { Sec2, Sec3, Sec5 } from "./components/Homecomponent";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import regulationImg from "../assets/images/regulations.png"
import notificationImg from "../assets/images/notification.png"
import { useLocation, useNavigate } from "react-router-dom/dist";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { Form } from "react-bootstrap";

const DirectorshipApplicationCat = () => {
	const location = useLocation();

	const navigate = useNavigate();
	const data = [
		{
			title: "Nolan Miller",
			desc: "Associate Professor of Finance",
			data: "In its endeavor to facilitate investors and effect ease of doing business, Central Depository Company (CDC) has collaborated again with the State Bank of Pakistan (SBP) for leveraging SBP’s RAAST Payment Gateway to allow mutual fund investors to transfer their investments to the mutual fund bank accounts. This project was mutually initiated by CDC and MUFAP who jointly approached SBP to extend the utility of RAAST payment gateway for facilitating mutual fund unit sales. CDC has developed a framework where it acts as an “Aggregator” and issues a Payment ID, enabling investors to easily purchase mutual fund units by transferring funds to the respective Asset Management Company (AMC) from any bank portal. The transfer of funds is instantaneous and completely cost-free through RAAST’s P2P facility. 			"
		},



	]
	const [modalShow, setModalShow] = useState(false);

	return (
		<>
			<PageHeader heading={location.state.title} />
			<div className="content_wrap">

				<section className='sec sec9'>
					<div className='container directorApplCat'>

						{data.map((e) => {
							return <>
								<h4 className="bold">{e.title}</h4>
								<h5>{e.desc}</h5>
								<p>{e.data}</p>
								<button onClick={() => setModalShow(true)} className="rounded_btn">Apply Now</button>

							</>
						})}
					</div>
				</section>
			</div>

			<Modal backdrop="static"
				centered
				dialogClassName="modal-90w"
				keyboard={false}
				show={modalShow}
				onHide={() => setModalShow(false)}
				aria-labelledby="contained-modal-title-vcenter">
				<Modal.Header className="modal-bg" closeButton>
					<Modal.Title id="contained-modal-title-vcenter">
						Apply Now
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="grid-example modal-bg">
					<Container>
						<Form>

							<Row>
								<Col xs={6} md={4}>

									<Form.Group controlId="formGroupFName">
										<Form.Label>First Name</Form.Label>
										<Form.Control className="formInput" placeholder="First Name*" />
									</Form.Group>

								</Col>

								<Col xs={6} md={4}>

									<Form.Group controlId="formGroupLName">
										<Form.Label>Last Name</Form.Label>
										<Form.Control className="formInput" placeholder="Last Name*" />
									</Form.Group>

								</Col>
								<Col xs={6} md={4}>

									<Form.Group controlId="formGroupEdu">
										<Form.Label>Educational qualification</Form.Label>
										<Form.Control className="formInput" placeholder="Masters*" />
									</Form.Group>

								</Col>
							</Row>
							<Row>
								<Col xs={12} md={6}>
									<Form.Group controlId="formGroupEdu">
										<Form.Label>Educational documents</Form.Label>
										<Form.Control className="formInput" type="file" />
									</Form.Group>
								</Col>
								<Col xs={6} md={6}>
									<Form.Group controlId="formGroupJob">
										<Form.Label>Job Experience</Form.Label>
										<Form.Control className="formInput" placeholder="Job Experience*" />
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col xs={12} md={6}>
									<Form.Label htmlFor="basic-url">Are you currently a Government employee?</Form.Label>
									<Form.Select className="formInput" aria-label="Default select example">
										<option value="Yes">Yes</option>
										<option value="No">No</option>
									</Form.Select>
								</Col>
								<Col xs={6} md={6}>
									<Form.Label>Completion of director training program?</Form.Label>
									<Form.Select className="formInput" aria-label="Default select example">
										<option value="No">No</option>
										<option value="Yes">Yes</option>
									</Form.Select>

								</Col>
							</Row>
							<Row>
								<Col xs={12} md={6}>
									<Form.Label>Application deadline</Form.Label>
									<Form.Control className="formInput" type="date" />
								</Col>
								<Col xs={6} md={6}>
									<Form.Label>Institute from where you have completed your director training program</Form.Label>
									<Form.Select className="formInput" aria-label="Default select example">
										<option value="PICG">PICG</option>
									</Form.Select>
								</Col>
							</Row>
							<Row>
								<Col xs={12} md={12}>
									<Form.Group controlId="formGroupEdu">
										<Form.Label>Resume upload</Form.Label>
										<Form.Control className="formInput" style={{ marginBottom: "0px" }} type="file" />
									</Form.Group>
								</Col>
							</Row>

						</Form>

					</Container>
				</Modal.Body>
				<Modal.Footer className="modal-bg">
					<button className="rounded_btn" onClick={() => setModalShow(false)}>Submit</button>
				</Modal.Footer>
			</Modal>

		</>
	);
};

export default DirectorshipApplicationCat;
